import { Injectable } from "@angular/core";
import { StoreBase } from "../shared/models/bases/storeBase";
import { Country } from "../shared/models";

@Injectable({
  providedIn: 'root'
})

export class CountryStore extends StoreBase<Country> { }
